<res-base-modal [modalTitle]="entityData.title" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [primaryButtonLabel]="'OK'" (primaryButtonActionEmt)="ok()" [isPrimaryBtnEnabled]="okEnabled()"
    [modalHasVariableHeight]="true" [secondaryButtonLabel]="'Cancel'" (closeButtonActionEmt)="modalOpened=false; closeModal(false)"
    [verifyRequiredValidator]="true" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
    [modalHelpIndex]="entityData.helpIndex">

    <res-name-description [name]="entityData.entity.name" [description]="entityData.entity.description"
        [validateNameRequest]="entityData.validateNameRequest" [validateName]="entityData.validateName"
        [automationId]="modalAutomationId" [bottomRowTemplate]="priorityTemplate"
        [popoverStickyClass]="popoverStickyClass" [customLabelWidth]="entityData.objectType == 'PROJECT' ? '100' : '70'"
        [isNameDisabled]="(entityData.objectType == 'PROJECT' && isExpressSystem && entityData.entity.autoCreatedReviewProject) || entityData.objectType == 'ORGANIZATION'">
    </res-name-description>

    <ng-template #priorityTemplate>
        <div class="modal-row" *ngIf="entityData.objectType == 'CUSTODIAN'">
            <div class="modal-row-column-auto"><label [attr.data-automation-id]="automationId + '-priority'"
                    for="priority">Priority:</label></div>
            <div class="modal-row-column-auto">
                <res-custom-checkbox automationId="new-custodian-priority"
                    [(ngModel)]="entityData.entity.priorityEnabled"
                    (ngModelChange)="entityData.entity.togglePriorityEnabled()" [checkOnMouseDown]="true">
                </res-custom-checkbox>
                <input class='input-priority' type="number" maxLength="3"
                    oninput="this.value=this.value.slice(0,this.maxLength)"
                    onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                    min="1" max="999" [disabled]="!entityData.entity.priorityEnabled"
                    [(ngModel)]="entityData.entity.priorityModal" (ngModelChange)="entityData.entity.updatePriority()"
                    data-automation-id="new-custodian-priority-input" />
            </div>
        </div>
        <div class="modal-row" *ngIf="entityData.objectType == 'PROJECT'">
            <div class="project-setup">
                <div>
                    <label>Review System:</label>
                </div>
                <div class="button-group">
                    <button [attr.data-automation-id]="modalAutomationId + '-digital-reef-only-button'" type="button"
                        [ngClass]="reviewSystem === reviewSystemEnum.NONE ? 'btn-group-active' : 'btn-group-default'"
                        (click)="onChange(reviewSystemEnum.NONE)"
                        [disabled]="entityData.originalReviewSystem !== reviewSystemEnum.NONE || selectedReviewProjects?.length > 0">
                        <div>Reef ECA Only</div>
                        <i class="fa fa-caret-up up-caret-active" [hidden]="reviewSystem !== reviewSystemEnum.NONE"></i>
                    </button>
                    <button [attr.data-automation-id]="modalAutomationId + '-reef-review-button'" type="button"
                        [ngClass]="reviewSystem === reviewSystemEnum.REEF_REVIEW ? 'btn-group-active' : 'btn-group-default'"
                        (click)="onChange(reviewSystemEnum.REEF_REVIEW)"
                        [disabled]="selectedReviewProjects?.length > 0 && reviewSystem !== reviewSystemEnum.REEF_REVIEW">
                        <div>Reef Review</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="reviewSystem !== reviewSystemEnum.REEF_REVIEW"></i>
                    </button>
                    <button [attr.data-automation-id]="modalAutomationId + '-relativity-server-button'" type="button"
                        [ngClass]="reviewSystem === reviewSystemEnum.RELATIVITY ? 'btn-group-active' : 'btn-group-default'"
                        (click)="onChange(reviewSystemEnum.RELATIVITY)"
                        [disabled]="selectedReviewProjects?.length > 0 && reviewSystem !== reviewSystemEnum.RELATIVITY">
                        <div>Relativity Server</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="reviewSystem !== reviewSystemEnum.RELATIVITY"></i>
                    </button>
                    <!-- <button [attr.data-automation-id]="modalAutomationId + '-relativity-one-button'" type="button"
                        [ngClass]="reviewSystem === reviewSystemEnum.RELATIVITY_ONE ? 'btn-group-active' : 'btn-group-default'"
                        (click)="onChange(reviewSystemEnum.RELATIVITY_ONE)" disabled="true">
                        <div>Relativity One</div>
                        <i class="fa fa-caret-up up-caret-active"
                            [hidden]="reviewSystem !== reviewSystemEnum.RELATIVITY_ONE"></i>
                    </button> -->
                </div>
            </div>
            <div class="project-setup fill-width top-margin" *ngIf="reviewSystem !== reviewSystemEnum.NONE">
                <div>
                    <label requiredAsterisk>Review Project:</label>
                </div>
                <div class="selected-review-project-section fill-width">
                    <div *ngFor="let reviewProject of selectedReviewProjects" class="selected-review-project-item"
                        [attr.data-automation-id]="modalAutomationId + '-existing-review-project-' + reviewProject.reviewProjectName">
                        <span class="reef-review-icons"
                            [title]="reviewProject.reviewSystem === reviewSystemEnum.RELATIVITY ? 'Reef ECA and Relativity project' : 'Reef ECA and Reef Review project'">
                            <i class="fa fa-clone"
                                [ngClass]="reviewProject.reviewSystem === reviewSystemEnum.RELATIVITY ? 'relativity-icon-color' : 'reef-review-icon-color'"></i>
                            <span
                                [ngClass]="reviewProject.reviewSystem === reviewSystemEnum.RELATIVITY ? 'relativity-icon-color' : 'reef-review-icon-color'">R</span>
                        </span>
                        {{reviewProject.reviewProjectName}}
                        <button type="button" class="remove-button" (click)="onRemoveClick(reviewProject)"
                            [attr.data-automation-id]="modalAutomationId + '-existing-review-project-' + reviewProject.reviewProjectName + '-remove-button'">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                    <button class="secondary-button select-projects-button" type="button" [disabled]="isExpressWithReviewProject" [title]="isExpressWithReviewProject ? 'A Reef Express project can be associated with only one Review project.' : ''"
                        (click)="openSelectReviewProjects()"
                        [attr.data-automation-id]="modalAutomationId + '-add-review-project-button'">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-row reef-express-row" *ngIf="entityData.objectType == 'PROJECT' && isExpressSystem">
            <span class="header" [attr.data-automation-id]="modalAutomationId + '-reef-express-header'">Reef
                Express</span>
            <div class="project-setup">
                <div>
                    <label>Project Type:</label>
                </div>
                <div class="radio-button-group">
                    <res-custom-radio-button [(ngModel)]="standardProjectType" content="Standard"
                        (ngModelChange)="onProjectTypeChanged()"
                        [automationId]="modalAutomationId + '-project-type-standard'" name="standardProject"
                        [value]="true">
                    </res-custom-radio-button>
                    <res-custom-radio-button [(ngModel)]="standardProjectType" content="Reef Claims"
                        (ngModelChange)="onProjectTypeChanged()"
                        [automationId]="modalAutomationId + '-project-type-reef-claims'" name="reefClaimsProject"
                        [value]="false">
                    </res-custom-radio-button>
                </div>
            </div>
            <div class="project-setup">
                <res-custom-input-file [disabled]="standardProjectType" [(ngModel)]="logoModel" [createFileMD5]="true"
                    labelText="Project Logo" [automationId]="modalAutomationId + '-project-logo'"
                    typesAccepted="image/jpeg,image/tiff,.bmp,.webp,.svg,.png" sizeLimitInMB="2"
                    deleteMessage="Delete Project Logo?">
                </res-custom-input-file>
            </div>
        </div>
    </ng-template>
</res-base-modal>